import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router';
import { Base } from 'zf-web-components';
import { Header } from '../header';
import { Sider } from '../sider';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { ContainerProps } from './types';

function LayoutComponent(props: ContainerProps): ReactElement {
  return (
    <Base.Layout hasSider={true}>
      <Sider show={props.sider} />
      <Base.Layout className={styles.content}>
        <Header />
        <Outlet />
      </Base.Layout>
    </Base.Layout>
  );
}

export const Layout = observer(LayoutComponent);
